
import React from 'react';
import { Carousel } from 'react-bootstrap';

const ServiceA2Z = () => {
    return (
        <div className="roadRiderzProject">
      <h1 className="projects-Header">Service A2Z</h1>
      <div className="row site-details-rrz">
        <div className="col-md-6 p-3">
        <p>
            * I am a project manager of this project & It’s Service Platform Related website..
          </p>
          <p>
            * Uses Technologies are React, Redux-Toolkit, Socket.io, NodeJs, MongoDB, Express,
Firebase Authentication, Material UI, Nodemailer, Stripe Payment etc. It’s has 4 Role.
          </p>
          <p>
            * UserRole: Recently view, Chat with executive without login, Unavailable Service Request,
Provider select and purchase, Payment with Strip, My order section and Add testimonial.
          </p>
          <p>
            *ProviderRole: Become a provider, Provider Profile, Dashboard, All appointment, Chat with
Customer, Make Service Request.
          </p>
          <p>*Admin: AdminDashboard, AddBanner, AddAdmin, Chat with User, ManageOrders,
ApproveTestimonials, Add new provider, and admin can manage all services.</p>
          
          {/* <p>* Also implement Authorization system </p> */}
        </div>
        <div className="col-md-6 p-3">
          <Carousel fade>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="https://i.ibb.co/k6qZCZ1/Screenshot-202.png"
                alt="First slide"
              />
              <Carousel.Caption>
                {/* <h3>First slide label</h3>
                <p>
                  Nulla vitae elit libero, a pharetra augue mollis interdum.
                </p> */}
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="https://i.ibb.co/LhRfgH6/Screenshot-204.png"
                alt="Second slide"
              />

              <Carousel.Caption>
                {/* <h3>Second slide label</h3>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="https://i.ibb.co/jfNyKgv/Screenshot-205.png"
                alt="Third slide"
              />

              <Carousel.Caption>
                {/* <h3>Third slide label</h3>
                <p>
                  Praesent commodo cursus magna, vel scelerisque nisl
                  consectetur.
                </p> */}
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="https://i.ibb.co/dMBF1zt/Screenshot-201.png"
                alt="Third slide"
              />

              <Carousel.Caption>
                {/* <h3>Fourth slide label</h3>
                <p>
                  Praesent commodo cursus magna, vel scelerisque nisl
                  consectetur.
                </p> */}
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
     <div className="siteInfo">
     <h3 className="seeLive">See Live: </h3>
      <span >
        {" "}
        <a className="liveSite" target="_blank" href="https://service-assistant-a2z.web.app/"><b>LiveSite</b></a>
      </span>
      <span >
        <a className="clientSide" target="_blank" href="https://github.com/Iasir-Arafat-riaz/Service-Assistant-TeamProject-Frontend"><b>ClientSideCode</b></a>
      </span>
      <span>
        <a className="serverSide" target="_blank" href="https://github.com/kawsarm104/service-assistant-a2z-backend"><b>ServerSideCode</b></a>
      </span>
     </div>
    </div>
    );
};

export default ServiceA2Z;